// extracted by mini-css-extract-plugin
export var languageSwitchTrigger = "LanguageSwitch-module--languageSwitchTrigger--P5o3g";